module.exports = __webpack_public_path__ + "static/media/jakubco.ca5b3bf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/jakubco.jpg
// module id = 502
// module chunks = 0